import { useState } from 'react';

import { useLastOrderAvailableToReorder } from '../../hooks/use-last-order-available-to-reorder';
import { ReorderDetailsDrawer } from '../reorder-details-drawer';

import { ReorderCard } from './reorder-card';

type ReorderCardProps = {
  openDetailEventMessage: string;
  isAvailable: () => boolean;
  logViewEvent: () => void;
  logReorderEvent: () => void;
  logOpenDetailEvent: () => void;
};

export const ReorderCardContainer = ({
  openDetailEventMessage,
  isAvailable,
  logViewEvent,
  logReorderEvent,
  logOpenDetailEvent,
}: ReorderCardProps) => {
  const lastOrder = useLastOrderAvailableToReorder();
  const [isDetailsDrawerOpen, setIsDetailsDrawerOpen] = useState(false);
  const toggleDetailsDrawer = () => setIsDetailsDrawerOpen(!isDetailsDrawerOpen);

  if (!lastOrder || !isAvailable()) {
    return null; // or any fallback UI when the order is not available
  }

  return (
    <>
      {isDetailsDrawerOpen ? (
        <ReorderDetailsDrawer
          order={lastOrder}
          showDrawer={isDetailsDrawerOpen}
          toggleDetailsDrawer={toggleDetailsDrawer}
          openDetailEventMessage={openDetailEventMessage}
        />
      ) : (
        <ReorderCard
          order={lastOrder}
          toggleDetailsDrawer={toggleDetailsDrawer}
          drawerIsOpen={isDetailsDrawerOpen}
          logViewEvent={logViewEvent}
          logReorderEvent={logReorderEvent}
          logOpenDetailEvent={logOpenDetailEvent}
        />
      )}
    </>
  );
};
